import {
  IAssembleiaAssessorLoadContas,
  IAssembleiasAssessorItens,
  IAssembleiasAssessorPauta,
} from 'store/modules/AssembleiasAssessorReducer';
import {
  IAssembleiaAssociadoPauta,
  IAssembleiaAssociadoPautaOpcao,
  IAssembleiaContaAssociado,
} from 'store/modules/AssembleiasAssociadoReducer';
import { WS_ASSEMBLEIAS_ACTION_DEFAULT_USUARIOS_ONLINE } from 'store/modules/WSAssembleiasActions';
import { Buffer } from 'buffer';

const ASSEMBLEIA_UTILS_USUARIOS_ONLINE_SESSION_VOTOS: string = Buffer.from(
  'ASSEMBLEIA_UTILS_USUARIOS_ONLINE_SESSION_VOTOS',
  'ascii'
).toString('base64');

export interface SessionUsuariosOnline {
  cpfCnpjLdap: string;
  idAssembleia: number;
  usuariosOnline: number;
}

const toEncrypt = (value: SessionUsuariosOnline[]): string => {
  const buff: Buffer = Buffer.from(JSON.stringify(value), 'ascii');
  return buff.toString('base64');
};

const toDecrypt = (value: string): SessionUsuariosOnline[] => {
  const buff: Buffer = Buffer.from(value, 'base64');
  return JSON.parse(buff.toString('ascii'));
};

export const assembleiaUtilsUsuariosOnlineSessionClear = () => {
  window.sessionStorage.setItem(
    ASSEMBLEIA_UTILS_USUARIOS_ONLINE_SESSION_VOTOS,
    toEncrypt([])
  );
};

const initializeSession = () => {
  if (
    !window.sessionStorage.getItem(
      ASSEMBLEIA_UTILS_USUARIOS_ONLINE_SESSION_VOTOS
    )
  ) {
    assembleiaUtilsUsuariosOnlineSessionClear();
  }
};

export const assembleiaUtilsGetUsuariosOnline = (): SessionUsuariosOnline[] => {
  initializeSession();
  return toDecrypt(
    window.sessionStorage.getItem(
      ASSEMBLEIA_UTILS_USUARIOS_ONLINE_SESSION_VOTOS
    ) as string
  ) as SessionUsuariosOnline[];
};

export const assembleiaUtilsUsuariosOnlineByIdAssembleia = (
  cpfCnpjLdap: string,
  idAssembleia: number
): SessionUsuariosOnline | null => {
  return (
    assembleiaUtilsGetUsuariosOnline().find(
      (it) => it.idAssembleia === idAssembleia && it.cpfCnpjLdap === cpfCnpjLdap
    ) || null
  );
};

export const assembleiaUtilsUsuariosOnlineByIdAssembleiaOrCurrent = (
  cpfCnpjLdap: string,
  idAssembleia: number,
  currentValue?: number
): number => {
  const usuariosOnline: SessionUsuariosOnline | null =
    assembleiaUtilsUsuariosOnlineByIdAssembleia(cpfCnpjLdap, idAssembleia);
  if (
    !usuariosOnline &&
    currentValue !== undefined &&
    currentValue > WS_ASSEMBLEIAS_ACTION_DEFAULT_USUARIOS_ONLINE
  ) {
    return currentValue;
  }
  return usuariosOnline &&
    usuariosOnline.usuariosOnline >
      WS_ASSEMBLEIAS_ACTION_DEFAULT_USUARIOS_ONLINE
    ? usuariosOnline.usuariosOnline
    : 0;
};

export const contaDisponivelParaSelecao = (
  conta: IAssembleiaAssessorLoadContas | IAssembleiaContaAssociado,
  // eslint-disable-next-line unused-imports/no-unused-vars
  cpfCnpjAssociado: string
): boolean => {
  // alguém já está presente com essa conta
  return conta.presente === false;
};

export const getContasDisponiveisParaSelecao = (
  contas: Array<IAssembleiaContaAssociado | IAssembleiaAssessorLoadContas>,
  cpfCnpjAssociado: string
) => {
  return contas.filter((conta): boolean => {
    return contaDisponivelParaSelecao(conta, cpfCnpjAssociado);
  });
};

export const getTotalContasDisponiveisParaSelecao = (
  contas: Array<IAssembleiaContaAssociado | IAssembleiaAssessorLoadContas>,
  cpfCnpjAssociado: string
): number => {
  return getContasDisponiveisParaSelecao(contas, cpfCnpjAssociado).length;
};

export const contaSelecionadaPeloUsuario = (
  conta: IAssembleiaContaAssociado | IAssembleiaAssessorLoadContas,
  cpfCnpjAssociado: string
): boolean => {
  // alguém já está presente e a conta atual é o representante legal desse convocado
  // alguém já está presente e a conta atual é o próprio convocado
  return (
    (conta.presente === true &&
      conta.cpfRepresentanteConfirmado === cpfCnpjAssociado) ||
    (conta.presente === true && conta.cpfCnpj === cpfCnpjAssociado)
  );
};

export const getContasSelecionadasPeloUsuario = (
  contas: Array<IAssembleiaContaAssociado | IAssembleiaAssessorLoadContas>,
  cpfCnpjAssociado: string
) => {
  return contas.filter((conta): boolean => {
    return contaSelecionadaPeloUsuario(conta, cpfCnpjAssociado);
  });
};

export const getTotalContasSelecionadasPeloUsuario = (
  contas: Array<IAssembleiaContaAssociado | IAssembleiaAssessorLoadContas>,
  cpfCnpjAssociado: string
): number => {
  return getContasSelecionadasPeloUsuario(contas, cpfCnpjAssociado).length;
};

export const contaSelecionadaOuNaoPeloUsuario = (
  conta: IAssembleiaContaAssociado | IAssembleiaAssessorLoadContas,
  cpfCnpjAssociado: string
): boolean => {
  // alguém já está presente com essa conta
  return (
    conta.presente === false ||
    conta.presente === true ||
    contaSelecionadaPeloUsuario(conta, cpfCnpjAssociado)
  );
};

export const getContasSelecionadasOuNaoPeloUsuario = (
  contas: Array<IAssembleiaContaAssociado | IAssembleiaAssessorLoadContas>,
  cpfCnpjAssociado: string
) => {
  return contas.filter((conta): boolean => {
    return contaSelecionadaOuNaoPeloUsuario(conta, cpfCnpjAssociado);
  });
};

export const getTotalContasSelecionadasOuNaoPeloUsuario = (
  contas: Array<IAssembleiaContaAssociado | IAssembleiaAssessorLoadContas>,
  cpfCnpjAssociado: string
): number => {
  return getContasSelecionadasOuNaoPeloUsuario(contas, cpfCnpjAssociado).length;
};

export const getContasSemContaUsuario = (
  contas: Array<IAssembleiaContaAssociado | IAssembleiaAssessorLoadContas>,
  cpfCnpj: string
) => {
  return contas.filter((conta): boolean => {
    return conta.cpfCnpj !== cpfCnpj;
  });
};

export const sortItensPautaById = (
  a: { idItemPauta: number },
  b: { idItemPauta: number }
) => {
  return a.idItemPauta - b.idItemPauta;
};

export const sortItensPautaByIdAndFlgAbstencao = (
  a: { idItemPauta: number; flgAbstencao?: number },
  b: { idItemPauta: number; flgAbstencao?: number }
) => {
  if (!a.flgAbstencao && b.flgAbstencao) return -1;
  if (a.flgAbstencao && !b.flgAbstencao) return 1;
  return a.idItemPauta - b.idItemPauta;
};

const sortItensPautaByFlg = (
  a: IAssembleiaAssociadoPautaOpcao,
  b: IAssembleiaAssociadoPautaOpcao
) => {
  if (!a.flgAbstencao && b.flgAbstencao) return -1;
  if (a.flgAbstencao && !b.flgAbstencao) return 1;
  return 0;
};

export const getPautaAssociadoWithOrderedOptions = (
  pauta: IAssembleiaAssociadoPauta
): IAssembleiaAssociadoPauta => {
  const sortedItems = Array.from(pauta.itens)
    .sort(sortItensPautaById)
    .sort(sortItensPautaByFlg);
  return {
    ...pauta,
    itens: sortedItems.map(
      (
        item: IAssembleiaAssociadoPautaOpcao,
        ordem: number
      ): IAssembleiaAssociadoPautaOpcao => {
        return {
          ...item,
          ordem,
        };
      }
    ),
  };
};

export const getPautaAssessorWithOrderedOptions = (
  pauta: IAssembleiasAssessorPauta
): IAssembleiasAssessorPauta => {
  const sortedItems = Array.from(pauta.itens)
    .sort(sortItensPautaById)
    .sort(sortItensPautaByFlg);
  return {
    ...pauta,
    itens: sortedItems.map(
      (
        item: IAssembleiasAssessorItens,
        ordem: number
      ): IAssembleiasAssessorItens => {
        return {
          ...item,
          ordem,
        };
      }
    ),
  };
};
